module.exports = __webpack_public_path__ + "img/detail.fedaf1e4.png";